import * as React from "react";
import Translate from "../../common/functions/translate";
import Spinner from '../../common/components/spinner/spinner';
import Snackbar from "../../common/components/snackbar/snackbar";
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import OfferService from '../../services/offerService';
import { OfferGridModel } from "../../models/offer/offerGridModel";
import { OfferFilterSettingsModel } from "../../models/offer/offerFilterSettingsModel";
import { OfferAdminModel } from "../../models/offer/offerAdminModel";
import OfferList from './offerList';
import OfferAddEditDialog from './offerAddEditDialog';
import OfferFilter from './offerFilter';
import AuthService from '../../services/authService';
import FileService from "../../services/fileService";
import { FileSystemType, OfferStatus } from "../../common/enums";
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import OfferTransferDialog from './offerTransferDialog';
import { OfferTransferModel } from "../../models/offer/offerTransferModel";
import { FileModel } from "../../models/fileModel";
import * as HelperFunctions from '../../common/functions/helperFunctions';
import GeneratePDFService from '../../services/generatePdfFromBase';

interface IProps {
}

interface IState {
    isLoading: boolean;
    error: any;
    from: number;
    numberOfRows: number;
    totalRecordsCount: number;
    validationMessage: string;
    isVisibleAddEditDialog: boolean;
    isVisibleConfirmDialog: boolean;
    offerSettings: OfferFilterSettingsModel;
    offers: Array<OfferGridModel>;
    currentOffer: OfferAdminModel;
    isVisibleRecalculateInfo: boolean;
    currentTraderName: string;
    currentOfferNumber: string;
    currentOfferId: number;
    selectedOffers: Array<OfferGridModel>;
    isVisibleTransferOffersDialog: boolean;
    allSelected: boolean;
}

const initFrom = 0;
const numberOfRows = 10;

class OffersContainer extends React.Component<IProps, IState> {
    authService = new AuthService();
    snackbar: any;
    offerService = new OfferService();
    messages: any;
    fileService = new FileService();
    generatePDFService = new GeneratePDFService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            isLoading: false,
            error: null,
            validationMessage: '',
            from: initFrom,
            numberOfRows: numberOfRows,
            totalRecordsCount: 0,
            isVisibleAddEditDialog: false,
            isVisibleConfirmDialog: false,
            offerSettings: new OfferFilterSettingsModel(),
            offers: new Array<OfferGridModel>(0),
            currentOffer: new OfferAdminModel(),
            isVisibleRecalculateInfo: false,
            currentTraderName: '',
            currentOfferNumber: '',
            currentOfferId: 0,
            selectedOffers: new Array<OfferGridModel>(0),
            isVisibleTransferOffersDialog: false,
            allSelected: false
        };
    }

    componentDidMount() {
        this.getAllOffers(this.state.from, this.state.numberOfRows);
    }

    getAllOffers(from: number, numberOfRows: number) {
        this.setState({
            isLoading: true
        });

        this.offerService.getAllOffers(from, numberOfRows, this.state.offerSettings).then(
            (data: any) => {
                let areAllSelected = false;
                let offersForCheck: Array<OfferGridModel> = data.offers.filter(r => r.offerStatusId !== OfferStatus.Finished);
                if (offersForCheck.every(v => this.state.selectedOffers.some(r => r.id === v.id)))
                    areAllSelected = true;

                this.setState({
                    isLoading: false,
                    from: from,
                    offers: data.offers,
                    totalRecordsCount: data.totalRecordsCount,
                    allSelected: areAllSelected
                })
            })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleOnPageClick = (e) => {
        const startIndex = e.first;

        this.setState({
            numberOfRows: e.rows
        }, () => this.getAllOffers(startIndex, this.state.numberOfRows))
    }

    handleSearchButtonClick = (settings) => {
        this.setState({
            isLoading: true,
            selectedOffers: new Array<OfferGridModel>(0),
            allSelected: false
        });

        this.offerService.getAllOffers(initFrom, numberOfRows, settings).then(
            (data: any) => {
                this.setState({
                    isLoading: false,
                    from: initFrom,
                    offers: data.offers,
                    offerSettings: settings,
                    totalRecordsCount: data.totalRecordsCount
                });
            })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleCancelButton = () => {
        this.showEditDialog(false);
    };

    showEditDialog = (show: boolean) => {
        this.setState({
            isVisibleAddEditDialog: show,
            validationMessage: ''
        });
        setTimeout(() => this.setState({
            isVisibleAddEditDialog: show
        }));
    };

    setCurrentOffer(offer: OfferAdminModel) {
        this.setState({ currentOffer: { ...offer } });
    }

    getOffer = (id) => {

        this.setState({
            isLoading: true
        });

        this.offerService.getOffer(id)
            .then(
                (data: OfferAdminModel) => {
                    this.setCurrentOffer(data);
                    this.setState({
                        isLoading: false
                    });
                })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleAddAndEditClick = (e, id) => {
        e.preventDefault();

        if (!id) { // Add			
            this.setCurrentOffer(new OfferAdminModel());
            this.showEditDialog(true);
        } else { // Edit
            this.setState({
                isLoading: true
            });
            this.offerService.getOffer(id)
                .then(
                    (data: OfferAdminModel) => {
                        this.setCurrentOffer(data);
                        this.showEditDialog(true);
                        this.setState({
                            isLoading: false
                        });
                    })
                .catch(error => {
                    this.snackbar.show({ severity: 'error', summary: error.message });
                    this.setState({
                        isLoading: false
                    });
                });
        }
    };

    handleDeleteClick = (id, e) => {
        e.stopPropagation();
        //this.getOffer(id);
        let currentOffer = this.state.offers.find(o => o.id === id);
        if (currentOffer) {
            this.setState({
                isVisibleConfirmDialog: true,
                currentOfferId: id,
                currentOfferNumber: currentOffer.offerNumber
            });
        }
    };

    deleteOffer(id) {
        this.setState({
            isVisibleConfirmDialog: false,
            isLoading: true
        });

        this.offerService.deleteOffer(id)
            .then(
                data => {
                    this.snackbar.show({ severity: 'success', summary: Translate('Deleted Successfully') });
                    this.getAllOffers(this.state.from, this.state.numberOfRows);
                    this.setState({
                        isLoading: false
                    });
                })
            .catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                });
            });
    }

    handleSaveButton = (offer: OfferAdminModel, close: boolean) => {
        this.setState({
            isLoading: true
        });

        if (!offer.id) { // Add
            this.offerService.addOffer(offer)
                .then(
                    (data) => {
                        if (!close)
                            this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });

                        this.handleCloseAddEditOfferModal(close);
                        this.setState({ isLoading: false })
                    },
                    error => {
                        this.snackbar.show({ severity: 'error', summary: error.message });
                        this.setState({
                            isLoading: false
                        })
                    }
                );
        } else { // Edit

            this.recreateOfferFileAndSaveOffer(offer, close);

        }
    };

    recreateOfferFileAndSaveOffer = (offer: OfferAdminModel, close: boolean) => {

        let oldOfferFile = offer.offerFiles.find(o => o.fileSystemTypeId === FileSystemType.Offer);
        if (oldOfferFile) {
            let removeIndex = offer.offerFiles.indexOf(oldOfferFile);
            if (removeIndex || removeIndex === 0) {
                offer.offerFiles.splice(removeIndex, 1);
            }
        }

        let totalAmount = 0;

        if (offer.gasInstallProducts && offer.gasInstallProducts.length > 0) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.gasInstallProducts);
        }

        if (offer.heathInstallProducts && offer.heathInstallProducts.length > 0) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.heathInstallProducts);
        }

        if (offer.gasAdditionalProducts && offer.gasAdditionalProducts.length > 0) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.gasAdditionalProducts);
        }

        if (offer.heathAdditionalProducts && offer.heathAdditionalProducts.length > 0) {
            totalAmount += HelperFunctions.calculateProductsPrice(offer.heathAdditionalProducts);
        }

        offer.offerPrice = totalAmount;

        let content = this.generatePDFService.getOfferContent(offer, totalAmount, offer.trader.name, offer.trader.phone);
        this.generatePDFService.createPDFDocument(offer, content).then((pdf: any) => {

            let file = this.createFile(oldOfferFile, pdf, (Translate('Offer') + " - " + offer.offerNumber));
            offer.offerFiles.unshift(file);

            this.offerService.editOffer(offer).then(
                (data) => {
                    if (!close)
                        this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });

                    this.handleCloseAddEditOfferModal(close);
                    this.setState({ isLoading: false })
                },
                error => {
                    this.snackbar.show({ severity: 'error', summary: error.message });
                    this.setState({
                        isLoading: false
                    });
                });
        });
    }

    createFile = (installationPdf, pdfFile, title) => {
        let newFile = installationPdf
        if (!newFile)
            newFile = new FileModel();

        newFile.fileContent = pdfFile;
        newFile.fileSizeInBytes = Math.round(pdfFile.length * 3 / 4);
        newFile.fileName = title;
        //newFile.updatedOn = HelperFunctions.fomatDateTimeAsString(new Date());
        return newFile
    }

    handleCloseAddEditOfferModal = (close: boolean) => {
        this.showEditDialog(close)
        this.setCurrentOffer(new OfferAdminModel());
        this.getAllOffers(this.state.from, this.state.numberOfRows);
    };

    handleDownloadFileClick = (event, id: number, fileName: string, fileSystemTypeId: number) => {
        event.stopPropagation();

        this.setState({ isLoading: true });
        this.fileService.getFileContent(id)
            .then(
                (data) => {
                    this.setState({ isLoading: false });
                    let contentType = fileSystemTypeId === FileSystemType.BillOfQuantities || fileSystemTypeId === FileSystemType.BillOfQuantitiesLabor
                        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        : 'application/pdf';
                    const linkSource = `data:${contentType};base64,${data.data.fileContent}`;
                    const downloadLink = document.createElement("a");
                    downloadLink.setAttribute('href', linkSource);
                    downloadLink.download = `${fileName}.${fileSystemTypeId === FileSystemType.BillOfQuantities || fileSystemTypeId === FileSystemType.BillOfQuantitiesLabor ? 'xlsx' : 'pdf'}`;;
                    downloadLink.click();
                },
                error => {
                    this.snackbar.show({ severity: 'error', summary: error.message });
                    this.setState({
                        isLoading: false
                    });
                }
            );
    }

    handleRecalculateClick = (id, e) => {
        e.stopPropagation();
        //this.getOffer(id);
        let currentOffer = this.state.offers.find(o => o.id === id);
        if (currentOffer) {
            this.setState({
                isVisibleRecalculateInfo: true,
                currentTraderName: currentOffer.traderName
            });
        }
    }

    handleDataSelection() {
        if (this.state.allSelected) {
            let currentAllowedOffers = this.returnSelectableOffers();
            let currentSelected = this.state.selectedOffers;

            let allSelectedOffers = currentSelected.concat(currentAllowedOffers);
            this.setState({
                selectedOffers: allSelectedOffers
            });
        }
    }

    returnSelectableOffers = () => {
        const { offers, selectedOffers } = this.state;

        return offers.filter(o => o.offerStatusId !== OfferStatus.Finished && !selectedOffers.some(r => r.id === o.id));
    }

    handleToggleAllDataRows = (allSelected: boolean) => {
        if (allSelected) {
            let allowedOffers = this.returnSelectableOffers();
            this.setState(prevState => ({
                selectedOffers: [...prevState.selectedOffers, ...allowedOffers],
                allSelected: allSelected
            }));
        }
        else {
            this.setState(prevProps => ({
                selectedOffers: [...prevProps.selectedOffers.filter(el => !this.state.offers.some(r => r.id === el.id))],
                allSelected: allSelected
            }));
        }
    }

    handleSelectDataRowClick = (e, item) => {
        let selectedOffers = this.state.selectedOffers;
        if (e.checked) {
            selectedOffers.push(item);
            let allSelected = selectedOffers.length === this.returnSelectableOffers().length;
            this.setState({
                allSelected: allSelected,
                selectedOffers: selectedOffers
            });
        }
        else {
            let removeIndex = selectedOffers.map(o => o.id).indexOf(item.id);
            if (removeIndex || removeIndex === 0) {
                selectedOffers.splice(removeIndex, 1);
                this.setState({
                    allSelected: false,
                    selectedOffers: selectedOffers
                });
            }
        }
    }

    handleTransferButtonClick = () => {
        this.showTransferDialog(true);
    }

    showTransferDialog = (show: boolean) => {
        this.setState({
            isVisibleTransferOffersDialog: show,
            validationMessage: ''
        });
    }

    handleTransferCancelButton = () => {
        this.showTransferDialog(false);
    };

    handleCloseTransferOfferModal = () => {
        this.showTransferDialog(false)
        this.setState({ selectedOffers: new Array<OfferGridModel>(0) });
        this.getAllOffers(this.state.from, this.state.numberOfRows);
    };

    handleTransferSaveButton = (offerTransfer: OfferTransferModel) => {
        this.setState({
            isLoading: true
        });

        let offerIds = offerTransfer.offers.map(o => o.id);
        this.offerService.getAdminOffersList(offerIds).then(
            (offers: Array<OfferAdminModel>) => {
                this.configureTransferData(offers, offerTransfer.trader).then(
                    (data: any) => {
                        offerTransfer.adminOffers = new Array<OfferAdminModel>();
                        offerTransfer.adminOffers = data;

                        this.offerService.transferOffer(offerTransfer)
                            .then(
                                (a) => {
                                    this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
                                    this.setState({ isLoading: false })
                                    this.handleCloseTransferOfferModal();
                                },
                                error => {
                                    this.snackbar.show({ severity: 'error', summary: error.message });
                                    this.setState({
                                        isLoading: false
                                    })
                                }
                            );
                    }
                ).catch(error => {
                    this.snackbar.show({ severity: 'error', summary: error.message });
                    this.setState({
                        isLoading: false
                    })
                })
            }).catch(error => {
                this.snackbar.show({ severity: 'error', summary: error.message });
                this.setState({
                    isLoading: false
                })
            })
    };

    configureTransferData = async (adminOffers: Array<OfferAdminModel>, trader) => {
        let returnArray = new Array<OfferAdminModel>();

        for await (let o of adminOffers) {
            await this.createNewOfferFile(o, trader).then(
                (updatedOffer: any) => {
                    returnArray.push(updatedOffer);
                }
            );
        }
        return returnArray;
    }

    createNewOfferFile = async (offer: OfferAdminModel, trader: any) => {
        return new Promise((resolve, reject) => {
            let oldOfferFile = offer.offerFiles.find(o => o.fileSystemTypeId === FileSystemType.Offer);
            if (oldOfferFile) {
                let removeIndex = offer.offerFiles.indexOf(oldOfferFile);
                if (removeIndex || removeIndex === 0) {
                    offer.offerFiles.splice(removeIndex, 1);
                }
            }

            let totalAmount = 0;
            if (offer.gasInstallProducts && offer.gasInstallProducts.length > 0) {
                totalAmount += HelperFunctions.calculateProductsPrice(offer.gasInstallProducts);
            }

            if (offer.heathInstallProducts && offer.heathInstallProducts.length > 0) {
                totalAmount += HelperFunctions.calculateProductsPrice(offer.heathInstallProducts);
            }

            if (offer.gasAdditionalProducts && offer.gasAdditionalProducts.length > 0) {
                totalAmount += HelperFunctions.calculateProductsPrice(offer.gasAdditionalProducts);
            }

            if (offer.heathAdditionalProducts && offer.heathAdditionalProducts.length > 0) {
                totalAmount += HelperFunctions.calculateProductsPrice(offer.heathAdditionalProducts);
            }
            offer.offerPrice = totalAmount;

            let content = this.generatePDFService.getOfferContent(offer, totalAmount, trader.name, trader.phone);
            this.generatePDFService.createPDFDocument(offer, content).then((pdf: any) => {
                let file = this.createFile(oldOfferFile, pdf, (Translate('Offer') + " - " + offer.offerNumber));
                offer.offerFiles.unshift(file);
                resolve(offer);
            }).catch(error => {
                reject(error);
            });
        });
    }

    public render() {
        const { offers, isLoading, numberOfRows, selectedOffers } = this.state;

        return (
            <div>
                <h1>{Translate("Offers")}</h1>

                {isLoading ? <Spinner /> : null}
                <Snackbar ref={(el) => this.snackbar = el} />

                {this.state.isVisibleAddEditDialog ? (
                    <OfferAddEditDialog
                        closeAddEditOfferModal={this.handleCloseAddEditOfferModal}
                        cancelClick={this.handleCancelButton}
                        saveClick={this.handleSaveButton}
                        currentOffer={this.state.currentOffer}
                        isVisible={this.state.isVisibleAddEditDialog}
                    />
                ) : null}

                <OfferFilter
                    onSearchClick={this.handleSearchButtonClick}
                    totalRecordsCount={this.state.totalRecordsCount}
                    transferButtonDisabled={selectedOffers.length < 1 || this.authService.checkIsTrader()}
                    transferButtonClick={this.handleTransferButtonClick}
                    trasferOffersCount={selectedOffers.length}
                    isVisibleTransferButton={!this.authService.checkIsTrader()}
                />

                {this.state.totalRecordsCount
                    ? <OfferList
                        offers={offers}
                        rows={numberOfRows}
                        totalRecords={this.state.totalRecordsCount}
                        onPageClick={this.handleOnPageClick}
                        first={this.state.from}
                        loading={Spinner}
                        editClick={this.handleAddAndEditClick}
                        deleteClick={this.handleDeleteClick}
                        downloadFileClick={this.handleDownloadFileClick}
                        isAdmin={this.authService.checkIsAdmin()}
                        recalculateClick={this.handleRecalculateClick}
                        selectedOffers={selectedOffers}
                        selectDataRowClick={this.handleSelectDataRowClick}
                        isVisibleSelectColumn={!this.authService.checkIsTrader()}
                        toggleAll={this.handleToggleAllDataRows}
                        allSelected={this.state.allSelected}
                    />
                    : <div style={{ marginLeft: 10 }}>
                        {Translate("NoRecordsFound")}
                    </div>
                }

                {/* <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "15px" }}>
                    <Button color="primary" variant="contained" style={{ marginRight: 10 }} onClick={() => this.handleAddAndEditClick(null)}>
                        {Translate("Add")}
                    </Button>
                </div> */}

                <ConfirmDialog
                    headerTitle={Translate("Confirm Dialog")}
                    isVisible={this.state.isVisibleConfirmDialog}
                    yesClick={() => { this.deleteOffer(this.state.currentOfferId) }}
                    noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
                    {Translate("Are you sure that you want to delete")} {Translate("offer")} "{this.state.currentOfferNumber}"?
                </ConfirmDialog>

                <Dialog
                    open={this.state.isVisibleRecalculateInfo}
                    onClose={() => { this.setState({ isVisibleRecalculateInfo: false }) }}
                >
                    <DialogTitle>
                        {Translate("Recalculate dialog")}
                    </DialogTitle>
                    <DialogContent>
                        <p>{Translate("Change in offer data.")}</p>
                        <p>{Translate("Please contact trader")} <strong>{this.state.currentTraderName}</strong><br />
                            {Translate("or his regional manager.")}</p>
                    </DialogContent>
                    <DialogActions>
                        <div>
                            <Button variant="contained" size="small" color="primary" onClick={() => { this.setState({ isVisibleRecalculateInfo: false }) }}>
                                <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                                {Translate('OK')}
                            </Button>
                        </div>
                    </DialogActions>
                </Dialog>

                {this.state.isVisibleTransferOffersDialog ? (
                    <OfferTransferDialog
                        cancelClick={this.handleTransferCancelButton}
                        saveClick={this.handleTransferSaveButton}
                        selectedOffers={selectedOffers}
                        isVisible={this.state.isVisibleTransferOffersDialog}
                    />
                ) : null}

            </div>
        )
    }
}

export default OffersContainer